import PropTypes from 'prop-types'
import React from 'react'
import config from 'Config'

const ContentMetaData = props => {
  const { createdBy = '', createdDate = '' } = props
  return (
    <h3>
      {!!createdDate && createdDate}{' '}
      {!!createdBy && `${config.locale === 'de' ? 'von' : 'by'} ${createdBy}`}
    </h3>
  )
}

ContentMetaData.propTypes = {
  createdBy: PropTypes.string,
  createdDate: PropTypes.string
}

export default ContentMetaData
